import { useEffect } from 'react';

export default function useAutoDismissSnack(openSnack, setOpenSnack, duration = 4000) {
  useEffect(() => {
    if (openSnack) {
      const t = setTimeout(() => setOpenSnack(false), duration);
      return () => clearTimeout(t);
    }
  }, [openSnack, setOpenSnack, duration]);
}
